

<div class="paymentContainer">
  <div class="row">
    <div class="col-md-9 col-12">
        <div class="text-right mb-3">
          <button (click) = "openAddPayment()" class="btn default-btn mr-3" mat-button>{{ 'AddPayment' | translate }}</button>
        </div>
        <div class="mb-2 d-flex align-items-center profile-bg" *ngFor="let item of paymentMethods; let i = index">
          <div class="mr-2 view-payment-iconSep"><img class="img-fluid view-payment-icon" src='assets/img/icons/mastercard.png' /> </div>
          <div class="mr-2 view-payment-info">
            <div class="mb-2 customer-title">{{item.name}}</div>
            <div>{{item.number}}</div>
            <div>Epires In {{item.expiryMonth}}-{{item.expiryYear}}</div>
            <div class="mt-2 payment-status-default" *ngIf="item.isDefault&&!item.expired">{{'Default'}}</div>
            <div class="mt-2 payment-status-expired" *ngIf="item.expired">{{'Expired'}}</div>
            <!-- <div class="mt-2 " [ngClass]="{'payment-status-default': item.isDefault , 'payment-status-expired':item.expired === 'Expired' }">{{item.status}}</div> -->
          </div>
          <div class="view-payment-delete">
            <div ngbDropdown class="dropdownList">
              <button class="btn toggle-btn" id="dropdownBasic1" ngbDropdownToggle>
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-toggle-menu list-card" ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <a  (click) = "editRow(i,item)"  class="dropdown-item dropdown-toggle-item" placement="bottom" ngbTooltip="{{ 'Edit' | translate }}"><mat-icon>edit</mat-icon></a>
                <a  (click) = "deleteRow(i,item)"  class="dropdown-item dropdown-toggle-item" placement="bottom" ngbTooltip="{{ 'Delete' | translate }}"><mat-icon>delete</mat-icon></a>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
